<template>
    <div class="space-y-4">
        <div class="sticky top-0 z-10 rounded-2xl border border-base-200/80 bg-base-100/95 p-4 shadow-sm backdrop-blur">
            <div class="flex items-start justify-between gap-3">
                <div><p class="text-sm font-semibold text-base-content">{{ activePanelMeta.title }}</p><p class="mt-1 text-xs leading-5 text-base-content/55">{{ activePanelMeta.description }}</p></div>
                <button class="btn btn-sm rounded-xl border border-base-300 bg-base-100 px-3 shadow-none" type="button" @click="toggleDetail">{{ detail ? '紧凑模式' : '详细模式' }}</button>
            </div>
            <div class="mt-3 flex flex-wrap gap-2">
                <button v-for="panel in panels" :key="panel.key" class="btn btn-xs rounded-xl border px-3 shadow-none" :class="activePanel === panel.key ? 'btn-primary border-primary text-primary-content' : 'border-base-300 bg-base-100'" type="button" @click="changePanel(panel.key)">{{ panel.shortLabel }}</button>
            </div>
        </div>
        <div class="rounded-[24px] border border-base-200/80 bg-base-100 p-3 md:p-4">
            <BatchSettings v-if="activePanel === 'batch-settings'" :detail="detail" :is-loading="isLoading" @loading-start="handleLoadingStart" @loading-end="handleLoadingEnd" />
            <BatchOperationRunner v-else :detail="detail" :is-loading="isLoading" :checked-data="checkedData" :file-path="filePath" @loading-start="handleLoadingStart" @loading-end="handleLoadingEnd" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BatchSettings from '@/components/batch/BatchSettings.vue'
import BatchOperationRunner from '@/components/batch/BatchOperationRunner.vue'

const PANEL_CATALOG = [
    { key: 'tag-editor', shortLabel: '批量编辑', title: '批量编辑', description: '所有批量操作与快捷指令使用同一份表单。' },
    { key: 'file-operations', shortLabel: '整理目录', title: '整理目录', description: '选择整理、删除目录或重命名等文件操作。' },
    { key: 'media-processor', shortLabel: '媒体处理', title: '媒体处理', description: '选择格式转换、CUE 分割、导入和重复检查。' },
    { key: 'text-processor', shortLabel: '文本处理', title: '文本处理', description: '选择简繁转换、拆分、替换或乱码修复。' },
    { key: 'file-indexer', shortLabel: '索引工具', title: '索引工具', description: '选择文件索引操作。' },
    { key: 'batch-settings', shortLabel: '更多设置', title: '更多设置', description: '查看和调整批量处理相关设置。' }
]

export default {
    name: 'HomeCloudBatchPanel',
    components: { BatchSettings, BatchOperationRunner },
    props: { panelKey: { type: String, default: 'tag-editor' } },
    data() { return { detail: false, isLoading: false, activePanel: 'tag-editor', panels: PANEL_CATALOG } },
    computed: {
        ...mapGetters(['geFullPath']),
        filePath() { return this.geFullPath },
        checkedData() { return this.$store.state.common.checkedData },
        activePanelMeta() { return this.panels.find(panel => panel.key === this.activePanel) || this.panels[0] }
    },
    watch: { panelKey: { immediate: true, handler(value) { this.activePanel = value || 'tag-editor' } } },
    methods: {
        toggleDetail() { this.detail = !this.detail },
        changePanel(panelKey) { this.activePanel = panelKey; this.$emit('change-panel', panelKey) },
        handleLoadingStart() { this.isLoading = true },
        handleLoadingEnd() { this.isLoading = false }
    }
}
</script>
